import type { ChainLpcLppSupplierSortMode } from '~/types/services/priceParrot';

export const HOTSPOT_RATIO_THRESHOLD = 0.8;

export const PERIOD_PRESETS: ReadonlyArray<{ key: string; label: string; days: number }> = [
  { key: '7d', label: '7d', days: 7 },
  { key: '30d', label: '30d', days: 30 },
  { key: '3mo', label: '3mo', days: 90 },
  { key: '6mo', label: '6mo', days: 180 },
  { key: '12mo', label: '12mo', days: 365 },
];

// 'ratio_asc' has no server-side equivalent — the BE doesn't store/sort by
// ratio, so this mode is applied as a client-side re-sort instead (see
// index.tsx's displayedProperties memo).
export type DisplaySortMode = ChainLpcLppSupplierSortMode | 'ratio_asc';

export const SORT_OPTIONS: ReadonlyArray<{ value: DisplaySortMode; label: string }> = [
  { value: 'views', label: 'Views' },
  { value: 'bookings', label: 'Bookings' },
  { value: 'margin', label: 'Margin' },
  { value: 'ratio_asc', label: 'Ratio' },
];

export const PROPERTIES_PAGE_SIZE = 15;
